import axios from "@/axios.js";
import SDStatus from "./sd_status_service";

export default {
  getAllSDStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      SDStatus.getAllSDStatus(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchSDStatus(context, sd_statusId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_status/sd_status/${sd_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllSDStatuses(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_status/sd_status/get_all_sd_statuses`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeSDStatus(context, sd_statusId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/sd_status/sd_status/${sd_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingSDStatusLists(context, sd_status_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_status/sd_status/get_existing_sd_status_lists/${sd_status_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingSDStatusLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_status/sd_status/search_existing_sd_status_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateSDStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_status/sd_status/update_sd_status", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addSDStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_status/sd_status/add_sd_status", {
          item: item
        })
        .then(response => {
  
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeSDStatus({ commit }, sd_statusId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/sd_status/sd_status/${sd_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
